import { MenuItem, TextField } from '@mui/material';
import { academicTitles } from '../../../../../Interfaces/IAcademicTitle';

type AcademicTitleInputProps = {
  value: number;
  onChange: (value: number) => void;
};

export function AcademicTitleInput({
  value,
  onChange,
}: AcademicTitleInputProps) {
  return (
    <TextField
      select
      label='Akademischer Titel'
      size='small'
      fullWidth
      required
      value={value}
      onChange={event => onChange(Number(event.target.value))}
    >
      {academicTitles.map(title => (
        <MenuItem key={title.idAcademicTitle} value={title.idAcademicTitle}>
          {title.AcademicTitle}
        </MenuItem>
      ))}
    </TextField>
  );
}
